import { Injectable } from '@angular/core';
import { Action, Store } from '@ngrx/store';
import { EnvironmentService } from '@proximus/ng-common';
import { ApplicationState } from '../store/reducers';
import { OrderEbuLog } from '../store/actions/ebu-ordering.actions';

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  constructor(
    private environmentService: EnvironmentService,
    private store: Store<ApplicationState>,
  ) {}

  logEpicCall(call: string | undefined) {
    this.log(`[${call}] Triggered at ${Date.now()}`);
  }

  logEpicCallSuccessful(call: string | undefined, data: Array<Action>) {
    this.log(`[${call}] Call succeeded`, data);
    return data;
  }

  logEpicCallError(
    call: string | undefined,
    data: Array<Action>,
    additionalMessageInfo?: string,
  ) {
    const errorData = {
      'error.type': 'api_error | technical',
      'error.detail': data,
    };

    this.log(`[${call}] Call Failed ${additionalMessageInfo}`, errorData);
    return data;
  }

  log(text: string, data?: any) {
    this.store.dispatch(new OrderEbuLog(text));
    if (this.envAllowed()) {
      console.log(text);
    }
  }

  envAllowed() {
    return (
      this.environmentService.isLocal ||
      this.environmentService.isItt ||
      this.environmentService.isUat
    );
  }
}
